import videojs from 'video.js';
import { Item } from './item.js';
import { getName } from './helpers.js';

export class Switch extends videojs.getComponent('MenuButton') {
	constructor(player, options) {
		super(player, options);
		this.menuButton_.addClass('vjs-visible-text');
	}

	createItems() {
		return this.options_.items.map((item, index) => {
			const itemComponent = new Item(this.player(), {
				controlText: getName(this.player(), item),
				className: 'vjs-visible-text',
				clickHandler: () => {
					this.options_.onClick(item);
				}
			});
			if (item.name === this.options_.activeItem.name) {
				itemComponent.addClass('vjs-selected');
			}
			return itemComponent;
		});
	}
}
